/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { LayoutState } from '../../../../common/types.tsx';

export const setIsChromeless =
	(isChromeless: boolean): Action<LayoutState> =>
	({ setState }) => {
		setState({
			isChromeless,
		});
	};
